module.exports = [{"label":"Numéro de dossier DFR","name":"numAwbBol","type":"autocomplete2"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/ressources/jsonfiles/etataquai-searchfields.json
// module id = ./src/assets/ressources/jsonfiles/etataquai-searchfields.json
// module chunks = main